"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DataObjectConverter_1 = require("../../core/conversions/DataObjectConverter");
/**
 * WindowItemTransferValidationDTOConverter
 *
 * @author PKr
 */


var SupplierAgreementTransferValidationDTOConverter =
/*#__PURE__*/
function (_DataObjectConverter_) {
  _inherits(SupplierAgreementTransferValidationDTOConverter, _DataObjectConverter_);

  function SupplierAgreementTransferValidationDTOConverter() {
    _classCallCheck(this, SupplierAgreementTransferValidationDTOConverter);

    return _possibleConstructorReturn(this, _getPrototypeOf(SupplierAgreementTransferValidationDTOConverter).apply(this, arguments));
  }

  return SupplierAgreementTransferValidationDTOConverter;
}(DataObjectConverter_1.DataObjectConverter);

exports.SupplierAgreementTransferValidationDTOConverter = SupplierAgreementTransferValidationDTOConverter;